import React from 'react';
import { Instagram, Twitter, Facebook, Mail } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-ink text-white pt-16 pb-8" data-id="element-25">
      <div className="container mx-auto px-4" data-id="element-26">
        <div className="flex flex-col items-center mb-12" data-id="element-27">
          <img src="https://cdn.magicpatterns.com/uploads/4kHsUvhEshuf3FoVMaUcrj/9AA5C7DC-B40A-4097-9517-E464CC630006.png" alt="Bucknut Emblem" className="h-32 w-auto mb-6 object-contain" data-id="element-28" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 text-center md:text-left mb-12 border-b border-white/10 pb-12" data-id="element-29">
          <div data-id="element-30">
            <h4 className="font-bold uppercase tracking-wider mb-4 text-silver" data-id="element-31">
              Shop
            </h4>
            <ul className="space-y-2" data-id="element-32">
              <li data-id="element-33">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-34">
                  Graded Cards
                </a>
              </li>
              <li data-id="element-35">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-36">
                  Raw Cards
                </a>
              </li>
              <li data-id="element-37">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-38">
                  Autographed Helmets
                </a>
              </li>
              <li data-id="element-39">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-40">
                  Memorabilia
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-41">
            <h4 className="font-bold uppercase tracking-wider mb-4 text-silver" data-id="element-42">
              Customer Service
            </h4>
            <ul className="space-y-2" data-id="element-43">
              <li data-id="element-44">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-45">
                  Shipping Policy
                </a>
              </li>
              <li data-id="element-46">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-47">
                  Returns & Refunds
                </a>
              </li>
              <li data-id="element-48">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-49">
                  FAQ
                </a>
              </li>
              <li data-id="element-50">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-51">
                  Track Order
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-52">
            <h4 className="font-bold uppercase tracking-wider mb-4 text-silver" data-id="element-53">
              About
            </h4>
            <ul className="space-y-2" data-id="element-54">
              <li data-id="element-55">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-56">
                  Our Story
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-58">
                  Authentication
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-60">
                  Consignment
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="hover:text-scarlet transition-colors" data-id="element-62">
                  Blog
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-63">
            <h4 className="font-bold uppercase tracking-wider mb-4 text-silver" data-id="element-64">
              Contact
            </h4>
            <ul className="space-y-2" data-id="element-65">
              <li data-id="element-66">
                <a href="mailto:hello@bucknut.com" className="hover:text-scarlet transition-colors" data-id="element-67">
                  hello@bucknut.com
                </a>
              </li>
              <li data-id="element-68">
                <a href="tel:+18005550199" className="hover:text-scarlet transition-colors" data-id="element-69">
                  1-800-555-0199
                </a>
              </li>
              <li className="pt-4 flex justify-center md:justify-start space-x-4" data-id="element-70">
                <a href="#" className="text-white hover:text-scarlet transition-colors" data-id="element-71">
                  <Instagram className="w-5 h-5" data-id="element-72" />
                </a>
                <a href="#" className="text-white hover:text-scarlet transition-colors" data-id="element-73">
                  <Twitter className="w-5 h-5" data-id="element-74" />
                </a>
                <a href="#" className="text-white hover:text-scarlet transition-colors" data-id="element-75">
                  <Facebook className="w-5 h-5" data-id="element-76" />
                </a>
                <a href="#" className="text-white hover:text-scarlet transition-colors" data-id="element-77">
                  <Mail className="w-5 h-5" data-id="element-78" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center text-silver text-sm" data-id="element-79">
          <p data-id="element-80">
            &copy; {new Date().getFullYear()} Bucknut Collectibles. All rights
            reserved.
          </p>
          <p className="mt-2 text-xs opacity-50" data-id="element-81">Managed by LetLois</p>
        </div>
      </div>
    </footer>;
};